<template>
    <div
        class="container-fluid myCoursesWeeduc page-card text-left"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div>
            <div class="w-100 d-flex justify-content-between align-items-start">
                <div class="pr-2">
                    <h3
                        data-aos="fade-left"
                        data-aos-duration="1500"
                        class="card-title"
                    >
                        Meus Cursos
                    </h3>
                    <p
                        data-aos="fade-left"
                        data-aos-duration="1500"
                        class="card-subtitle"
                    >
                        Gerencie seus cursos ou crie novos. Arraste-os para
                        mudar a ordem de visualizacao no portal do aluno.
                    </p>
                </div>

                <a
                    class="btnd btnd--purple btnd--prepend-icon text-capitalize pr-4 pr-md-6"
                    title="Criar novo curso"
                    @click="() => this.$router.push('/dashboard/form-curso')"
                >
                    <v-icon class="mr-0 mr-md-2">mdi-plus</v-icon>
                    <span class="d-none d-md-block">Novo curso</span>
                </a>
            </div>
            <hr class="page-card__divider mb-3" />

            <v-row class="mb-1" data-aos="fade-left" data-aos-duration="1500">
                <v-col cols="12" sm="8" lg="5">
                    <v-text-field
                        type="text"
                        v-model="searchText"
                        placeholder="Pesquisar curso..."
                        variant="outlined"
                        hide-details
                        density="compact"
                        class="inputd mr-md-2 flex-grow-1"
                        append-inner-icon="mdi-magnify"
                        clearable
                        @input="buscarColecao"
                        @click:clear="buscarColecao"
                    />
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="4" lg="3">
                    <v-select
                        v-model="statusFilter"
                        :items="statusFilterOptions"
                        item-title="text"
                        item-value="value"
                        label="Status"
                        variant="outlined"
                        class="inputd"
                        density="compact"
                        hide-details
                        @update:modelValue="filtrarPorStatus"
                    />
                </v-col>
            </v-row>

            <div
                class="d-flex align-items-center viewOptionsContainer myCoursesWeeduc"
                style="gap: 12px"
            >
                <button
                    class="btnViewOption"
                    :class="{ active: view === 1 }"
                    @click="changeView(1)"
                    title="Visualização em blocos"
                >
                    <v-icon>mdi-view-grid</v-icon>
                </button>
                <button
                    class="btnViewOption"
                    :class="{ active: view === 2 }"
                    @click="changeView(2)"
                    title="Visualização em lista"
                >
                    <v-icon>mdi-view-list</v-icon>
                </button>
            </div>
        </div>

        <!-- *** CHANGE 1: Added v-if condition to disable draggable on mobile screens *** -->
        <draggable
            v-if="!isMobileIcon"
            :list="collections"
            :disabled="false"
            class="list-group"
            :class="{ grid: view === 1, list: view === 2 }"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="onDragEnd"
            data-aos="fade-up"
            data-aos-duration="1500"
        >
            <template #item="{ element }">
                <div
                    class="list-group-item myCoursesWeeduc"
                    :id="`collection-${element.id}`"
                >
                    <div
                        class="item"
                        @click="goToCollection(element.id, element)"
                    >
                        <div class="drag-handle" v-if="dragging">
                            <v-icon>mdi-drag</v-icon>
                        </div>
                        <div
                            class="backgroundItemCollection"
                            :class="{ noImage: !element.imageFinalPath2 }"
                            :style="{
                                backgroundImage: element.imageFinalPath2
                                    ? `url('${element.imageFinalPath2}')`
                                    : `url('${require('@/assets/Weflix/default-video-thumbnail.jpg')}')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }"
                        ></div>
                        <div
                            class="itemContent"
                            :class="{ noImage: !element.imageFinalPath }"
                        >
                            <div class="titleItemCollection">
                                <span>{{ element.comercialName }}</span>
                                <br />
                                <small>{{ element.shortDescription }}</small>
                            </div>
                            <!-- <div class="descriptionItemCollection" style="display: flex; align-items: center; gap: 12px;">
                      <p style="margin-bottom: 0;"><v-icon>mdi-account-group</v-icon> {{element.studentQty}} Alunos</p>
                      <span class="status-flag" :class="element.status == 1 ? 'active' : 'inactive'">
                          Status: <span>{{ element.status == 1 ? 'Ativo' : 'Inativo' }}</span>
                      </span>
                  </div>   -->
                        </div>
                    </div>
                </div>
            </template>
        </draggable>

        <!-- *** CHANGE 2: Added v-else block for non-draggable version on mobile *** -->
        <div
            v-else
            class="list-group"
            :class="{ grid: view === 1, list: view === 2 }"
            data-aos="fade-up"
            data-aos-duration="1500"
        >
            <div
                v-for="element in collections"
                :key="element.id"
                class="list-group-item myCoursesWeeduc"
                :id="`collection-${element.id}`"
            >
                <div class="item" @click="goToCollection(element.id, element)">
                    <!-- *** CHANGE 3: Removed drag-handle div for mobile version *** -->
                    <div
                        class="backgroundItemCollection"
                        :class="{ noImage: !element.imageFinalPath2 }"
                        :style="{
                            backgroundImage: element.imageFinalPath2
                                ? `url('${element.imageFinalPath2}')`
                                : `url('${require('@/assets/Weflix/default-video-thumbnail.jpg')}')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }"
                    ></div>
                    <div
                        class="itemContent"
                        :class="{ noImage: !element.imageFinalPath }"
                    >
                        <div class="titleItemCollection">
                            <span>{{ element.comercialName }}</span>
                            <br />
                            <small>{{ element.shortDescription }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Loader :hasReady="hasReady" />
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import apiCollections from '@/utils/Weflix/collections';
    import Loader from '@/components/Weflix/Loader';
    import draggable from 'vuedraggable';
    import ApiModules from '@/utils/modules';
    import { VSelect } from 'vuetify/components';

    let id = 1;

    export default {
        data() {
            return {
                collections: [],
                hasReady: false,
                dragging: false,
                showCollections: false,
                isMobileIcon: false,
                searchText: '',
                view: 1,
                numberCourses: 0,
                numberModules: 0,
                numberLessons: 0,
                allCollections: [],
                searchDebounceTimeout: null,
                statusFilter: '1',
                statusFilterOptions: [
                    { text: 'Todos', value: 'all' },
                    { text: 'Ativos', value: '1' },
                    { text: 'Inativos', value: '4' },
                ],
            };
        },
        mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
        },
        beforeDestroy() {
            if (this.searchDebounceTimeout) {
                clearTimeout(this.searchDebounceTimeout);
            }
            window.removeEventListener('resize', this.checkScreenSize);
        },
        computed: {
            ...mapState(['token', 'panelData', 'currentCollections']),
        },
        methods: {
            ...mapActions(['storeCurrentCollections']),

            goToCollection(id, collections) {
                this.storeCurrentCollections({
                    currentCollections: collections,
                });
                this.$router.push('/dashboard/curso');
            },
            async getCollections() {
                try {
                    const response = await apiCollections.getCollection(
                        this.token
                    );
                    const sortedCollections = response.sort((a, b) => {
                        const orderA = Number(a.order) || 0;
                        const orderB = Number(b.order) || 0;
                        return orderA - orderB;
                    });

                    this.allCollections = [...sortedCollections];
                    this.filtrarPorStatus();
                    this.statusFilter = '1';
                    this.numberCourses = response.length;
                    this.numberModules = response.reduce(
                        (total, collection) => total + collection.moduleQty,
                        0
                    );
                    this.numberLessons = response.reduce(
                        (total, collection) => total + collection.lessonQty,
                        0
                    );
                    this.hasReady = true;
                } catch (error) {
                    console.error('Erro ao obter dados das coleções:', error);
                }
            },
            checkMove: function (e) {},
            onDragEnd: function (e) {
                const movedElement = this.collections[e.newIndex];

                // Filtrar collections para obter apenas order e id
                const collectionOrderAndId = this.collections.map((item) => ({
                    id: item.id,
                    nome: item.comercialName,
                    order: this.collections.indexOf(item) + 1,
                }));
                this.updateCollectionOrder(collectionOrderAndId);
                this.dragging = false;
            },
            async updateCollectionOrder(collectionOrderAndId) {
                try {
                    const response = await apiCollections.updateCollectionOrder(
                        this.token,
                        collectionOrderAndId
                    );
                } catch (error) {
                    console.error('Erro ao atualizar ordem da coleção:', error);
                }
            },
            checkScreenSize() {
                this.isMobileIcon = window.innerWidth <= 600;
            },
            buscarColecao() {
                clearTimeout(this.searchDebounceTimeout);

                this.searchDebounceTimeout = setTimeout(() => {
                    let filtradas = [...this.allCollections];

                    // Aplica filtro de status
                    if (this.statusFilter !== 'all') {
                        filtradas = filtradas.filter(
                            (collection) =>
                                String(collection.status) === this.statusFilter
                        );
                    }

                    // Aplica filtro de busca
                    if (this.searchText && this.searchText.trim()) {
                        const searchLower = this.searchText
                            .toLowerCase()
                            .trim();
                        filtradas = filtradas.filter((collection) => {
                            const nameMatch = collection.comercialName
                                .toLowerCase()
                                .includes(searchLower);
                            return nameMatch;
                        });
                    }

                    this.collections = filtradas;

                    if (this.collections.length > 0) {
                        this.$nextTick(() => {
                            const firstMatch = this.collections[0];
                            const element = document.getElementById(
                                `collection-${firstMatch.id}`
                            );
                            if (element) {
                                element.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                });
                            }
                        });
                    }
                }, 300);
            },
            changeView(view) {
                this.view = view;
            },
            filtrarPorStatus() {
                // Aplica o filtro de status e busca
                let filtradas = [...this.allCollections];
                if (this.statusFilter !== 'all') {
                    filtradas = filtradas.filter(
                        (collection) =>
                            String(collection.status) === this.statusFilter
                    );
                }
                // Se houver texto de busca, aplica também
                if (this.searchText.trim()) {
                    const searchLower = this.searchText.toLowerCase().trim();
                    filtradas = filtradas.filter((collection) => {
                        const nameMatch = collection.comercialName
                            .toLowerCase()
                            .includes(searchLower);
                        return nameMatch;
                    });
                }
                this.collections = filtradas;
            },
            async getStatusCourse() {
                try {
                    const response = await ApiModules.getStatusCourse(
                        this.token,
                        this.currentCollections.id
                    );
                    this.infoCount = response;
                } catch (error) {
                    console.error('Erro ao pegar status do curso:', error);
                }
            },
        },
        components: {
            Loader,
            draggable,
            VSelect,
        },
        created() {
            this.getCollections();
            this.getStatusCourse();
        },
    };
</script>
<style scoped>
    @import '@/css/weeduc/admin/courses.css';

    .status-filter {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .status-filter label {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        gap: 3px;
    }
    .status-filter input[type='radio'] {
        accent-color: #250891;
    }
    /* O select nativo não é mais usado, mas mantive o estilo para compatibilidade */
    .status-filter select {
        background-color: #fff !important;
        color: #250891 !important;
        border: 1px solid #250891 !important;
        padding: 4px 8px !important;
        border-radius: 4px !important;
        font-size: 16px !important;
        transition: border-color 0.3s, box-shadow 0.3s !important;
        outline: none !important;
        box-shadow: none !important;
        font-family: inherit !important;
        border: 1px solid #cccccc !important;
        text-align: center;
        font-size: 15px !important;
    }

    .status-filter select:focus {
        border-color: #160266;
        box-shadow: 0 0 0 2px rgba(37, 8, 145, 0.1);
    }

    .status-filter select option {
        color: #250891;
        background: #fff;
    }

    /* Estilos adicionais para garantir que o background seja aplicado */
    .backgroundItemCollection {
        min-height: 200px;
        width: 100%;
        display: block;
    }

    .backgroundItemCollection.noImage {
        background-color: #f5f5f5;
    }
</style>
